import { getLineItemProduct } from './get-line-item-product.js';
import { getProductTitle } from './get-product-title.js';

function getLensAttrLabel(intl, key) {
    const PREFIX = 'products.contactLenses';
    const opts = {
        hideLabelKey: true
    };
    return ({
        power: intl.getLabel(`${PREFIX}.prescription.power`, opts),
        baseCurve: intl.getLabel(`${PREFIX}.prescription.baseCurve`, opts),
        diameter: intl.getLabel(`${PREFIX}.prescription.diameter`, opts),
        cylinder: intl.getLabel(`${PREFIX}.prescription.cylinder`, opts),
        axis: intl.getLabel(`${PREFIX}.prescription.axis`, opts),
        addition: intl.getLabel(`${PREFIX}.prescription.addition`, opts),
        left: intl.getLabel(`${PREFIX}.leftEye`, opts),
        right: intl.getLabel(`${PREFIX}.rightEye`, opts)
    })[key];
}
const getContactLensA11yLabel = (prescription, eyeSide, intl, a11yLabel)=>{
    const { power , baseCurve , diameter , cylinder , axis , addition  } = prescription;
    // prepend label with eyeSide if eyeSide is 'left' or 'right'
    if (eyeSide) {
        const attr = getLensAttrLabel(intl, eyeSide.toLowerCase());
        a11yLabel = [
            attr,
            a11yLabel
        ].join(', ');
    }
    const lensAttributes = {
        power,
        baseCurve,
        diameter,
        cylinder,
        axis,
        addition
    };
    return Object.entries(lensAttributes).reduce((acc, [key, value])=>{
        const label = getLensAttrLabel(intl, key);
        if (!label || !value) {
            return acc;
        }
        return acc + `, ${label}: ${value}`;
    }, a11yLabel);
};
function getProductA11yLabel(lineItem, intl) {
    const quantityLabel = intl.getLabel('cart.item.quantity');
    let a11yLabel = getProductTitle(getLineItemProduct(lineItem), intl);
    if (lineItem.quantity) {
        a11yLabel += `, ${quantityLabel}: ${lineItem.quantity}`;
    }
    return a11yLabel;
}

export { getContactLensA11yLabel, getProductA11yLabel };
//# sourceMappingURL=get-product-a11y-label.js.map
